export const routes = (parentName) => {
  return [
    {
      path: "reagent",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Reagent`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-Reagent-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "special",
          name: `${parentName}-Reagent-List-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "deposit",
          name: `${parentName}-Reagent-List-Deposit`,
          component: () => import("./ListDeposit.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "lunch",
          name: `${parentName}-Reagent-List-Lunch`,
          component: () => import("./ListLunch.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Reagent-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Reagent-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Reagent-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
